module.exports = __webpack_public_path__ + "img/foreplay-gray.34a1a4b0.svg";